<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-box"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-plus-circle"></i>
          </div>
          <span class="card-header-title">{{ texts.dados_unidade }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <div class="form-field half">
              <label class="form-label">{{ labels.tipo_de_unidade }} <span class="required">*</span></label>
              <input type="text" pInputText [(ngModel)]="form.tipoUnidade"
                [placeholder]="placeholders.tipo_de_unidade"
                [class.error-field]="isFormSubmitted && !form.tipoUnidade"
                class="w-full" />
            </div>
            <div class="form-field half">
              <label class="form-label">{{ labels.nome }} <span class="required">*</span></label>
              <input type="text" pInputText [(ngModel)]="form.nome"
                [placeholder]="placeholders.nome"
                [class.error-field]="isFormSubmitted && !form.nome"
                class="w-full" />
            </div>
            <div class="form-field third">
              <label class="form-label">{{ labels.casas_decimais }}</label>
              <input type="number" pInputText [(ngModel)]="form.casasDecimais"
                [placeholder]="placeholders.casas_decimais" class="w-full" />
            </div>
            <div class="form-field half">
              <label class="form-label">{{ labels.codigo_dte }}</label>
              <input type="number" pInputText [(ngModel)]="form.codigoDTE"
                [placeholder]="placeholders.codigo_dte" class="w-full" />
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparForm()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.adicionar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.salvar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="alterarUnidadeMedidaDeItem()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.unidades_de_medida }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.nova_unidade" icon="pi pi-plus"
              (click)="novaUnidade()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchNome"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="products" [loading]="loading"
            (onSort)="onSortChange($event)"
            [sortField]="lastfield" [sortOrder]="lastSort === 'asc' ? 1 : -1"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('codigoDTE')" pSortableColumn="codigoDTE" style="width: 10%">
                  {{ labels.codigo_dte }}<p-sortIcon [field]="'codigoDTE'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('tipoUnidade')" pSortableColumn="tipoUnidade" style="width: 18%">
                  {{ labels.tipo_de_unidade }}<p-sortIcon [field]="'tipoUnidade'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 20%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('casasDecimais')" pSortableColumn="casasDecimais" style="width: 12%">
                  {{ labels.casas_decimais }}<p-sortIcon [field]="'casasDecimais'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('status')" pSortableColumn="ativo" style="width: 12%">
                  {{ labels.status }}<p-sortIcon [field]="'ativo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 14%">
                  {{ labels.data_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 13%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-product>
              <tr>
                <td [hidden]="!isColumnVisible('codigoDTE')">{{ product.codigoDTE }}</td>
                <td [hidden]="!isColumnVisible('tipoUnidade')">{{ product.tipoUnidade }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ product.nome }}</td>
                <td [hidden]="!isColumnVisible('casasDecimais')">{{ product.casasDecimais }}</td>
                <td [hidden]="!isColumnVisible('status')">
                  <span class="status-badge" [ngClass]="product.ativo ? 'status-ativo' : 'status-inativo'">
                    {{ product.ativo ? botoes.ativo : botoes.inativo }}
                  </span>
                </td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(product.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <!-- Estrela preenchida: unidade padrao atual (universal, readonly) -->
                  <button *ngIf="ehPadrao(product)" pButton icon="pi pi-star-fill"
                    class="p-button-text p-button-rounded p-button-sm btn-padrao-ativo"
                    [pTooltip]="tooltips.unidade_padrao" tooltipPosition="top"
                    [disabled]="true">
                  </button>

                  <!-- Estrela vazia: acao definir como padrao (apenas master) -->
                  <button *ngIf="!ehPadrao(product) && isMaster" pButton icon="pi pi-star"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.definir_padrao" tooltipPosition="top"
                    [disabled]="definindoPadraoId === product.id"
                    (click)="definirComoPadrao(product)">
                  </button>

                  <p-inputSwitch [(ngModel)]="product.ativo"
                    (onChange)="alternarStatus(product)"
                    class="status-switch-table"
                    [pTooltip]="product.ativo ? botoes.ativo : botoes.inativo"
                    tooltipPosition="top">
                  </p-inputSwitch>
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarUnidadeMedidaDeItem(product)">
                  </button>
                  <button pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarUnidadeMedidaDeItem(product.id)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhuma_unidade }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.adicione_nova_unidade }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange3($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first3" [rows]="rows3"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows3"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  (onShow)="onDeleteDialogShow()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar + ' (Esc)'" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button #deleteConfirmBtn pButton [label]="botoes.confirmar + ' (Enter)'" icon="pi pi-trash"
      style="gap: 0.35rem"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<p-toast />
